// extracted by mini-css-extract-plugin
export default {"header":"header_header__TRXcv","center":"header_center__UmnJh","ctrl":"header_ctrl__E8Rc8","logo":"header_logo__I8ERj","view":"header_view__XE83c"};